export default "__VITE_PUBLIC_ASSET__30fb352a__"